// extracted by mini-css-extract-plugin
var _1 = "CarouselContent_container__4vZ9R";
var _2 = "CarouselContent_productCarousel__DFdAF";
var _3 = "CarouselContent_reviewCarousel__z0k9J";
export { _1 as "container", _2 as "productCarousel", _3 as "reviewCarousel" }
